import { type FC } from "react";
import { Controller, type Control } from "react-hook-form";

import { useDetailsInlineSaving } from "@ds/components/details-view/hooks";
import { InputText } from "@ds/components/forms/inputs";
import { LabelWrapper } from "@ds/components/forms/labels";

export const AddressStreet2Control: FC<{
  control: Control<Locality>;
  excludeLabel?: boolean;
  autoFocus?: boolean;
  onBlur?: () => void;
}> = ({ control, excludeLabel, autoFocus, onBlur }) => {
  const onBlurHandler = useDetailsInlineSaving(onBlur);

  return (
    <Controller
      name="address.street_address.1"
      control={control}
      render={({ field: { ref, onBlur: onBlurFn, ...restFields }, fieldState }) => {
        const element = (
          <InputText
            inputRef={ref}
            placeholder="Apt, suite, unit, building, floor, etc."
            autoFocus={autoFocus}
            onBlur={onBlurHandler(onBlurFn)}
            {...restFields}
          />
        );

        if (excludeLabel) {
          return element;
        }

        return (
          <LabelWrapper label="Address Line 2" error={fieldState.error}>
            {element}
          </LabelWrapper>
        );
      }}
    />
  );
};
